import { withPrefix } from 'gatsby';
import { filter, find, isNil, propEq } from 'ramda';
import ResizeObserver from 'resize-observer-polyfill';

import { isWindowAvailable } from './browserObjectsAvailability';

export const toRadians = (degrees) => (degrees * Math.PI) / 180;

export const toDegrees = (radians) => (radians * 180) / Math.PI;

export const filterOffNils = filter((value) => !isNil(value));

export const findBy = (type) => (name, collection) => find(propEq(type, name))(collection) || {};
export const findByOrder = findBy('order');
export const findByName = findBy('name');
export const findByType = findBy('type');

const isExternalLink = (value) => value.indexOf('http') >= 0;

export const getTarget = (value = '') => (isExternalLink(value) ? '_blank' : undefined);

export const getWithPrefix = (value = '') => (isExternalLink(value) ? value : withPrefix(value));

export const getQueryStringValue = (key) =>
  isWindowAvailable() &&
  decodeURIComponent(
    window.location.search.replace(
      new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[.+*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'),
      '$1'
    )
  );

const addResizeObserver = () => {
  if (isWindowAvailable() && !window.ResizeObserver) window.ResizeObserver = ResizeObserver;
};

addResizeObserver();
